import React, { createContext, useContext, useState, useCallback } from 'react';

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [employee, setEmployee] = useState(() => {
    try {
      const raw = sessionStorage.getItem('portalEmployee');
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  });
  const [mustChangePassword, setMustChangePassword] = useState(() =>
    sessionStorage.getItem('portalMustChange') === 'true'
  );

  const login = useCallback((token, empData, mustChange) => {
    sessionStorage.setItem('portalToken', token);
    sessionStorage.setItem('portalEmployee', JSON.stringify(empData));
    sessionStorage.setItem('portalMustChange', mustChange ? 'true' : 'false');
    setEmployee(empData);
    setMustChangePassword(!!mustChange);
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem('portalToken');
    sessionStorage.removeItem('portalEmployee');
    sessionStorage.removeItem('portalMustChange');
    setEmployee(null);
    setMustChangePassword(false);
  }, []);

  const clearMustChange = useCallback(() => {
    sessionStorage.setItem('portalMustChange', 'false');
    setMustChangePassword(false);
  }, []);

  return (
    <PortalAuthContext.Provider value={{ employee, mustChangePassword, login, logout, clearMustChange }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  return useContext(PortalAuthContext);
}
